const config = window.cigna ?? {};

// TODO: Document this `window.universal_components_svg_url`
config.svgPath = window.universal_components_svg_url || process.env.SVG_URL;
config.staticPath = process.env.STATIC_PATH;

export const updateConfig = (cfg) => Object.assign(config, cfg);

export default config;
